import HeroSection from './components/HeroSection';
import VisualShowcase from './components/VisualShowcase';
import BrandStatement from './components/BrandStatement';
import CollectionsSection from './components/CollectionsSection';
import FirstDropSection from './components/FirstDropSection';
import EmailCapture from './components/EmailCapture';
import FooterSection from './components/FooterSection';

export default function Home() {
  return (
    <main className="grain-overlay bg-[#0A0A0A] min-h-screen w-full overflow-x-hidden">
      <HeroSection />
      <VisualShowcase />
      <BrandStatement />
      <CollectionsSection />
      <FirstDropSection />
      <EmailCapture />
      <FooterSection />
    </main>
  );
}
